import React from 'react';
import Slider from 'react-slick';
import Achievement from './achievement';
import PropTypes from 'prop-types';

class AchievementSlider extends React.Component {

	//The wrapper div on the slide is not required in current version of slick. Remove when we can update.
	render() {
		return (
			<div className="achievement-slider">
				<div className="title">{this.props.title}</div>
				<Slider
              		infinite={false}
              		arrows={true}
              		variableWidth={true}
              		slidesToScroll={3}
              		swipeToSlide={true}>
              		{this.props.achievements.map( (achievement, i) => {
              			return (
              				<div key={i}>
	              			<Achievement 
	              				name={achievement.name}
	              				image={achievement.image}
	              				completed={achievement.completed}/>
	              			</div>
              			);
              		})}
              	</Slider>
			</div>
		);
	}

}

AchievementSlider.propTypes = {
  title: PropTypes.string.isRequired,
  achievements: PropTypes.array.isRequired,
};

export default AchievementSlider;